const myLib = require("./MyLib");
export function validate(danhmuc, kehoach) {
  var result = { error: false };
  switch (danhmuc) {
    case "coquan":
      if (myLib.isEmpty(kehoach.TenCoQuan)) {
        result.error = true;
        result.TenCoQuan = { error: true, trangthai: "Chưa có tên" };
      }
      break;
    case "nguoidung":
      if (myLib.isEmpty(kehoach.MaCQ)) {
        result.error = true;
        result.MaCQ = { error: true, trangthai: "Chưa có cơ quan" };
      }
      if (myLib.isEmpty(kehoach.UserName)) {
        result.error = true;
        result.UserName = { error: true, trangthai: "Chưa có tài khoản" };
      }
      break;
    case 'doitac':
      if(kehoach.LoaiDoiTac + '' === '2' && (kehoach.MaQG === undefined || kehoach.MaQG.value === null)) {
        result.error = true;
        result.MaQG = {error: true, trangthai: 'Chưa có quốc gia'};
      }
      break;
  }

  return result;
}
export function chuanHoa(danhmuc, sukien) {
  switch (danhmuc) {
    case "tausar":
      sukien.TenTau = sukien.TenTau.toUpperCase();
      break;
    default:
      break;
  }
  return sukien;
}
export function chuyenDoi(danhmuc, sukien) {
  switch(danhmuc) {
    case 'doitac':
      sukien.MaQG = {value: sukien.MaQG, label: sukien.TenQuocGia};
      break;
    case 'khuvuc':
      sukien.MaVung = {value: sukien.MaVung, label: sukien.TenVung};
      break;
    case 'tausar':
      sukien.LoaiTau = {value: sukien.LoaiTau, label: sukien.TenLoaiTau}
      break;
  }
  return sukien;
}
